module.exports = __webpack_public_path__ + "static/img/pauls-photo-1-350x350.af779a0d.jpg";